//
// Copyright (C) 2023 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/DumpOptions.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/DumpOptions.proto.
 */
export const file_android_hardware_automotive_vehicle_DumpOptions: GenFile = /*@__PURE__*/
  fileDesc("CjVhbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9EdW1wT3B0aW9ucy5wcm90bxIpYW5kcm9pZC5oYXJkd2FyZS5hdXRvbW90aXZlLnZlaGljbGUucHJvdG8iHgoLRHVtcE9wdGlvbnMSDwoHb3B0aW9ucxgBIAMoCWIGcHJvdG8z");

/**
 * @generated from message android.hardware.automotive.vehicle.proto.DumpOptions
 */
export type DumpOptions = Message<"android.hardware.automotive.vehicle.proto.DumpOptions"> & {
  /**
   * @generated from field: repeated string options = 1;
   */
  options: string[];
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.DumpOptions.
 * Use `create(DumpOptionsSchema)` to create a new message.
 */
export const DumpOptionsSchema: GenMessage<DumpOptions> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_DumpOptions, 0);

